module.exports = __webpack_public_path__ + "static/img/edgar-mobile.d71998bf.webp";